import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useEffect ,useRef } from "react";
import useLogin from "../admin-hooks/UseLogin";
import { useState } from "react";
import Swal from "sweetalert2";
function Login() {
  useEffect(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("CentCode");
        localStorage.removeItem("activeTab");
        localStorage.removeItem("schoolName");
        localStorage.removeItem("sessionId");
        localStorage.removeItem("token2");
        localStorage.removeItem("sessionId2");
    }, []);
    const {
        loading,
        showPassword,
        schoolCode,
        password,
        setShowPassword,
        setSchoolCode,
        setPassword,
        handleLogin,
    } = useLogin();

        const [captcha, setCaptcha] = useState("");
        const [userCaptcha, setUserCaptcha] = useState("");
        const [isCaptchaValid, setIsCaptchaValid] = useState(false);
        const canvasRef = useRef(null);
    
        const generateCaptcha = () => {
            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let randomCaptcha = "";
            for (let i = 0; i < 6; i++) {
                randomCaptcha += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            setCaptcha(randomCaptcha);
            setUserCaptcha("");  // Clear user input
            setIsCaptchaValid(false);  // Reset validation state
            drawCaptcha(randomCaptcha);
        };
    
        const drawCaptcha = (captchaText) => {
            const canvas = canvasRef.current;
            if (!canvas) return;
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
    
            // Set background color
            ctx.fillStyle = "#f0f0f0";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
    
            // Set font style
            ctx.font = "italic bold 30px 'Courier New', monospace";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
    
            // Add random noise for security
            for (let i = 0; i < 150; i++) {
                ctx.fillStyle = `rgba(0, 0, 0, ${Math.random() * 0.3})`;
                ctx.fillRect(Math.random() * canvas.width, Math.random() * canvas.height, 1, 1);
            }
    
            // Draw distorted CAPTCHA text
            for (let i = 0; i < captchaText.length; i++) {
                const x = 20 + i * 20;
                const y = 20 + Math.random() * 5;
                const angle = (Math.random() - 0.5) * 0.5;
    
                ctx.save();
                ctx.translate(x, y);
                ctx.rotate(angle);
                ctx.fillStyle = `rgb(${Math.random() * 100}, ${Math.random() * 100}, ${Math.random() * 100})`;
                ctx.fillText(captchaText[i], 0, 0);
                ctx.restore();
            }
        };
        // Validate CAPTCHA input
        const validateCaptcha = (e) => {
            setUserCaptcha(e.target.value);
            setIsCaptchaValid(e.target.value === captcha);
        };
    const handleLoginWithCaptcha = async () => {
            if (!isCaptchaValid) {
                Swal.fire({
                    icon: "error",
                    title: "Invalid CAPTCHA",
                    text: "Please enter the correct CAPTCHA.",
                    confirmButtonColor: "#d33",
                });
                generateCaptcha();
                return;
            }
     
            await handleLogin();
            generateCaptcha();
        };
        useEffect(() => {
            generateCaptcha(); // Generate CAPTCHA on component mount
        }, []);

    return (
        <div>
            {loading && (
                <div className="custom-loader-container">
                    <div className="custom-loader"></div>
                </div>
            )}

            <div class="auth-main">
                <div class="auth-wrapper v3">
                    <div class="auth-form">
                        <div class="auth-header">
                            <a href="#"><img src="../assets/images/MBOSE.png" height={120} alt="img" /></a>
                            {/* <h3 className='exam-name'>Supplimentary and Improvement Exam</h3> */}
                        </div>
                        <div>
                            <h3 className='exam-name'>Supplementary Examination Portal</h3>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-end mb-4">
                                    <h3 class="mb-0"><b>Board Login</b></h3>
                                </div>
                                <div class="form-group mb-3">
                                    <label class="form-label">Login ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Board Login ID"
                                        value={schoolCode}
                                        onChange={(e) => setSchoolCode(e.target.value)}
                                        onKeyDown={(e) => {
                                            const keyCode = e.which || e.keyCode;

                                            // Allow only letters (A-Z, a-z), Backspace, Delete, and Tab
                                            if (
                                                !/[a-zA-Z]/.test(e.key) &&
                                                e.key !== "Backspace" &&
                                                e.key !== "Delete" &&
                                                e.key !== "Tab"
                                            ) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />

                                </div>
                                <div class="form-group mb-3">
                                    <label class="form-label">Password</label>
                                    <div className="input-group mb-3">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="form-control"
                                            placeholder="Password"
                                            aria-describedby="basic-addon2"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <span className="input-group-text cursor-pointer" id="basic-addon2" onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                                        </span>
                                    </div>
                                </div>
                                <div className="form-group mb-3 text-center">
                                    <canvas ref={canvasRef} width="140" height="40" style={{ border: "1px solid #ddd" }}></canvas>
                                    <button style={{ marginTop: '-33px' }} type="button" onClick={generateCaptcha} className="btn btn-secondary ms-2">↻ Refresh</button>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Enter CAPTCHA</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter CAPTCHA"
                                        value={userCaptcha}
                                        onChange={validateCaptcha}
                                    />
                                </div>

                                <div className="d-grid mt-3">
                                    <button type="button"  className="btn btn-primary" onClick={handleLoginWithCaptcha}>Login</button>
                                </div>
                            </div>
                        </div>
                        <div class="auth-footer row">
                            <div class="col my-1">
                                <p class="m-0 copyright" >Copyright © <a href="https://www.mbose.in/" target='_blank'>Meghalaya Board of School Education</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login